// extracted by mini-css-extract-plugin
export default {"container":"start_container__ua1Eu","title":"start_title__ditFS","contents":"start_contents__gRnI1"};